import {
  GlobalNav as V3GlobalNav,
  GlobalNavProps,
} from '@stadionhq-v3/base-ui';
import classnames from 'classnames';
import styles from './globalNav.module.scss';

const GlobalNav = ({
  classNames,
  globalNavDropdownTrigger,
  globalNavLinks,
  currentUrl,
  ...props
}: GlobalNavProps) => {
  const classes = classnames([styles.tokens, styles.globalNav], classNames);

  return (
    <V3GlobalNav
      classNames={[classes]}
      globalNavDropdownTrigger={
        globalNavDropdownTrigger && {
          ...globalNavDropdownTrigger,
          classNames: [classnames(styles.globalNavDropdownTrigger)],
        }
      }
      globalNavLinks={globalNavLinks.map((link) => ({
        ...link,
        classNames: [
          classnames(styles.globalNavLink, {
            [`${styles.navItemLevelFourSelected}`]:
              link.isSelected || link.url === currentUrl,
          }),
        ],
      }))}
      currentUrl={currentUrl}
      {...props}
    />
  );
};

export default GlobalNav;
